export default __webpack_public_path__ + "static/media/330_portfolio04-nl-mobile.35494a41.png";